export default {"src":"/_next/static/media/textile.40df4cf2.svg","height":160,"width":160};